module.exports = __webpack_public_path__ + "img/logo.a7bc7fff.png";